'use strict';

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var _tslib = require('./_tslib-bcbe0269.js');

var React = require('react');

var React__default = _interopDefault(React);

var colors = require('./colors/colors.js');

var assertUnreachable = require('./assertUnreachable-18645656.js');
/**
 * Default values for each property
 */


var defaults = {
  endIconAs: React__default.createElement("div", null),
  hoverColor: colors.colors.silver.light,
  iconSize: "normal",
  padding: "normal",
  selectedColor: colors.colors.blue.base,
  startIconAs: React__default.createElement("div", null)
};
/**
 * Context holding all configuration options for lists
 */

var ListConfigContext = React__default.createContext(undefined);
/**
 * Provider to set list config on the context
 */

var ListConfigProvider = function ListConfigProvider(_a) {
  var children = _a.children,
      props = _tslib.__rest(_a, ["children"]);

  return React__default.createElement(ListConfigContext.Provider, {
    value: props
  }, children);
};

function useListConfig() {
  return _tslib.__assign(_tslib.__assign({}, defaults), React__default.useContext(ListConfigContext) || {});
}

function verticalListMarginFromPadding(padding) {
  return padding === "normal" ? 0 : padding === "relaxed" ? 10 : assertUnreachable.assertUnreachable(padding);
}

exports.ListConfigProvider = ListConfigProvider;
exports.useListConfig = useListConfig;
exports.verticalListMarginFromPadding = verticalListMarginFromPadding;